import React from "react";
import { Controller } from "react-hook-form";
import FIlterSelect from "../filter-select";
import Input from "../input";
import PhoneNumberInput from "../phone-input";

interface Details {
  control: any;
  clearErrors: any;
  errors: any;
  supplier: any;
}

const SupplierDetails: React.FC<Details> = ({ control, supplier }) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="items-center gap-4">
        <Controller
          name="name"
          defaultValue={supplier?.name}
          control={control}
          rules={{
            required: "Supplier is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full"
              label="Supplier Name"
              placeholder="Enter Supplier Name"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>

      <div className="items-center gap-4">
        <Controller
          name="businessType"
          defaultValue={supplier?.businessType}
          control={control}
          render={({ field }) => (
            <FIlterSelect
              name="businessType"
              options={[
                { value: "retailer", label: "Greenhouse Producer" },
                { value: "wholesaler", label: "Open Field Farm" },
                {
                  value: "distributor",
                  label: "Greenhouse and Open Field Farm",
                },
              ]}
              className="w-full"
              label="Supplier Type"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
              }}
              value={field.value}
            />
          )}
        />
      </div>

      <div className="items-center gap-4">
        <Controller
          name="contactPerson"
          defaultValue={supplier?.contactPerson}
          control={control}
          rules={{
            required: "Contact name is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full"
              label="Contact Name"
              placeholder="Enter Contact Name"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>

      {/* Common Fields */}
      <div className="items-center gap-4">
        <Controller
          name="phone"
          defaultValue={supplier?.phone}
          control={control}
          rules={{
            required: "Phone Number is required",
          }}
          render={({ field, fieldState }) => (
            <PhoneNumberInput
              value={field.value}
              label="Phone Number"
              className="w-full"
              placeholder="080XXXXXXXX"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>

      <div className="items-center gap-4">
        <Controller
          name="email"
          control={control}
          defaultValue={supplier?.email}
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Enter a valid email.",
            },
          }}
          render={({ field, fieldState }) => (
            <Input
              label="Email"
              value={field.value}
              placeholder="Enter Email"
              className="w-full"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>

      <div className="items-center gap-4">
        <Controller
          name="businessCity"
          control={control}
          defaultValue={supplier?.businessCity}
          render={({ field }) => (
            <FIlterSelect
              name="businessCity"
              options={[
                { value: "yaba", label: "Yaba" },
                { value: "ikeja", label: "Ikeja" },
              ]}
              className="w-full"
              label="Region"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
              }}
              value={field.value}
            />
          )}
        />
      </div>

      <div className="items-center gap-4">
        <Controller
          name="bankName"
          control={control}
          defaultValue={supplier?.bankName}
          rules={{
            required: "Bank name is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full"
              label="Bank Name"
              placeholder="Enter Bank Name"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>
      <div className="items-center gap-4">
        <Controller
          name="bankAccountName"
          defaultValue={supplier?.bankAccountName}
          control={control}
          rules={{
            required: "Account Name is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full"
              label="Account Name"
              placeholder="Enter Account Name"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>
      <div className="items-center gap-4">
        <Controller
          name="bankAccountNumber"
          defaultValue={supplier?.bankAccountNumber}
          control={control}
          rules={{
            required: "Account Number is required",
            validate: {
              exactLength: (value) =>
                value.length === 10 ||
                "Account number must be exactly 10 digits",
              onlyNumbers: (value) =>
                /^\d+$/.test(value) ||
                "Account number must contain only numbers",
            },
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              className="w-full"
              label="Account Number"
              placeholder="Enter Account Number"
              error={fieldState?.error?.message}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                field.onChange(value);
              }}
            />
          )}
        />
      </div>
    </div>
  );
};

export default SupplierDetails;
